<template>
    <b-button class="btn-table" :id="`view-log-btn-${id}`" @click="$emit('click')">
        <DynamicIcon icon="clock-one-color" classString="icon-btn-table"/>
        <b-tooltip :target="`view-log-btn-${id}`" triggers="hover" :title="titleTooltip" custom-class="tooltip-item-btn" noninteractive/>
    </b-button>
</template>

<script>
import DynamicIcon from "@/components/commons/dynamicIcon/DynamicIcon.vue";

export default {
    components: {
       DynamicIcon
    },
    props: {
        id: Number,
        titleTooltip: String
    }
}
</script>


<style scoped lang="scss">
</style>
